import { render, staticRenderFns } from "./Allocated.vue?vue&type=template&id=5185a22e&scoped=true&"
import script from "./Allocated.vue?vue&type=script&lang=js&"
export * from "./Allocated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5185a22e",
  null
  
)

export default component.exports